import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { LabelWidthTypes } from "@enums/label-width-types";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";
import { MessagingTemplateContentValidationErrors, MessagingTemplateVariablesValidationErrors } from "@idw-types/common/validation/messaging-template/messaging-template-validation-errors";
import { ThemingConfigurationContainer } from "@containers/common/theming-configuration-container/theming-configuration-container";
import { ThemingFormContainer } from "@containers/common/theming-form-container/theming-form-container";
import { MessagingTemplateVariablesFormSection } from "@containers/messaging-template-details/messaging-template-details-component/messaging-template-variables-tab/messaging-template-variables-form-section/messaging-template-variables-form-section";
import { MessagingTemplatePreviewContainer } from "@containers/messaging-template-details/messaging-template-details-component/messaging-template-preview-container/messaging-template-preview-container";
import { MessagingTemplateContentFormSection } from "@containers/messaging-template-details/messaging-template-details-component/messaging-template-content-tab/messaging-template-content-form-section/messaging-template-content-form-section";

type MessagingTemplateContentTabProps = {
    state: FormattedMessagingTemplate;
    isDisabled: boolean;
    labelWidth: LabelWidthTypes;
    selectedLanguage: LocaleTypes;
    contentValidationErrors: MessagingTemplateContentValidationErrors;
    variablesValidationErrors: MessagingTemplateVariablesValidationErrors;
    setSelectedLanguage: (language: LocaleTypes) => void;
    setMessagingTemplateState: (state: FormattedMessagingTemplate) => void;
};

export const MessagingTemplateContentTab = (props: MessagingTemplateContentTabProps) => {
    const {
        state,
        labelWidth,
        isDisabled,
        selectedLanguage,
        contentValidationErrors,
        variablesValidationErrors,
        setSelectedLanguage,
        setMessagingTemplateState
    } = props;

    const handleUpdateTemplate = (event: React.ChangeEvent<any>) => {
        setMessagingTemplateState({
            ...state,
            template: event.target.value
        });
    }

    return (
        <ThemingConfigurationContainer>
            <ThemingFormContainer>
                <MessagingTemplateContentFormSection
                    isDisabled={isDisabled}
                    labelWidth={labelWidth}
                    handleUpdateTemplate={handleUpdateTemplate}
                    state={state}
                    validationErrors={contentValidationErrors}
                />
                <MessagingTemplateVariablesFormSection
                    isDisabled={isDisabled}
                    labelWidth={labelWidth}
                    selectedLanguage={selectedLanguage}
                    setMessagingTemplateState={setMessagingTemplateState}
                    setSelectedLanguage={setSelectedLanguage}
                    state={state}
                    validationErrors={variablesValidationErrors}
                />
            </ThemingFormContainer>
            <MessagingTemplatePreviewContainer
                state={state}
                selectedLanguage={selectedLanguage}
            />
        </ThemingConfigurationContainer>
    );
};